import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { Period, PERIODS } from "@/shared/domain/metrics";
import { Button } from "@/shared/foundation/primitives";

import styles from "./MetricsControls.module.css";
import { TIME_RANGES, TimeRange } from "./timeRange";

export interface MetricsControlsProps {
  range: TimeRange;
  period: Period;
  onRangeChange: (range: TimeRange) => void;
  onPeriodChange: (period: Period) => void;
}

/**
 * Global dashboard controls: a time-range preset selector plus an aggregation
 * period button group. The orchestrator owns the state; on a range change it
 * also auto-fits the period (see `periodForRange`).
 */
export function MetricsControls({
  range,
  period,
  onRangeChange,
  onPeriodChange,
}: MetricsControlsProps) {
  const handleRange = (e: SelectChangeEvent) =>
    onRangeChange(e.target.value as TimeRange);

  return (
    <div className={styles.controls}>
      <FormControl size="small" className={styles.rangeSelect}>
        <InputLabel id="time-range-label">Time range</InputLabel>
        <Select
          labelId="time-range-label"
          label="Time range"
          value={range}
          onChange={handleRange}
        >
          {TIME_RANGES.map((tr) => (
            <MenuItem key={tr.value} value={tr.value}>
              {tr.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <div className={styles.group}>
        <span className={styles.groupLabel}>Period</span>
        <div className={styles.periodButtons}>
          {PERIODS.map((p) => (
            <Button
              key={p}
              size="small"
              variant={p === period ? "contained" : "outlined"}
              onClick={() => onPeriodChange(p)}
            >
              {p.charAt(0).toUpperCase() + p.slice(1)}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
